import { Component, OnInit } from "@angular/core";
import { StorageService } from "src/app/core/helpers/storage-Service";
import { PaymentService } from "../../services/payment.service";

import { ToastrService } from "ngx-toastr";
import { CheckoutSettings } from "src/app/core/models/model";

@Component({
    selector: "app-experience-rating",
    templateUrl: "./experience-rating.component.html",
    styleUrls: ["./experience-rating.component.css"],
    standalone: false
})
export class ExperienceRatingComponent implements OnInit {
	feedback: string = "";
	clientId: string;
	checkoutSettings: CheckoutSettings;

	stars: number[] = [1, 2, 3, 4, 5];
	hoveredRating: number = 0;
	selectedRating: number = 0;

	feedbackList = [
		{ name: "Ease of use", showWhenMax: false, max: 3 },
		{ name: "Fast Transactions", showWhenMax: false, max: 3 },
		{ name: "Secure experience", showWhenMax: false, max: 3 },
		{ name: "Delayed", showWhenMax: true, max: 3 },
		{ name: "Error encountered", showWhenMax: true, max: 3 },
		{ name: "Not user friendly", showWhenMax: true, max: 3 },
	];

	constructor(
		private storageService: StorageService,
		private paymentService: PaymentService,
		private toastr: ToastrService,
	) { }

	ngOnInit() {
		this.clientId = this.storageService.getClientId() ?? this.storageService.getClientDetails().clientId ?? "";
		this.checkoutSettings = this.storageService.getPaymentInfo();
	}

	goBack() {
		window.history.back();
	}

	handleMouseEnter(star: number): void {
		this.hoveredRating = star;
	}

	handleMouseLeave(): void {
		this.hoveredRating = 0;
	}

	selectRating(rating: number): void {
		this.selectedRating = rating;
	}

	isStarActive(star: number): boolean {
		return star <= (this.hoveredRating || this.selectedRating);
	}

	selectFeedback(feedback: string): void {
		this.feedback = feedback;
	}

	submitReview() {
		const payload = {
			stars: this.selectedRating,
			feedback: this.feedback,
			clientId: this.clientId,
		};

		this.paymentService.createRating(payload).subscribe({
			next: (res) => {
				this.toastr.success("Feedback submitted successfully");
				this.selectedRating = 0;
				this.feedback = "";
				this.goBack();
			},
			error: (err) => {
				this.toastr.error("An error occured, please try again");
			},
		});
	}
}
